import { render } from "./m-card-result-view.vue?vue&type=template&id=7dab6d70&scoped=true&ts=true"
import script from "./m-card-result-view.vue?vue&type=script&lang=ts"
export * from "./m-card-result-view.vue?vue&type=script&lang=ts"

import "./m-card-result-view.vue?vue&type=style&index=0&id=7dab6d70&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dab6d70"]])

export default __exports__